import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import StoreParent from './StoreParent';

import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Login from './components/Login';
import { SuccessPage } from './components/success';

ReactDOM.render(
    <Router>
        
        <Route exact path="/" render={(props) => <App key="app_page" {...props}></App>} />
        <Route exact path="/store" render={(props) => <StoreParent key="store_page" {...props}></StoreParent>} />
        <Route exact path="/success" component={SuccessPage} />
        <Route exact path="/login" component={Login} />
    
    </Router>, 
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
